<template>
    <div class="assets-shoes-details">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.push({ name: 'assetsSummary' });">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div> 
                    
                    <div class="col-md-4">
                        <div class="top-navbar-center">
                            Shoes Details
                        </div>
                    </div>      

                    <div class="col-md-4">
                        <div class="top-navbar-right">
                            <button class="btn btn-ecdc">Export Report</button>
                        </div>
                    </div>                       
                </div>
            </div>

            <hr />

            <div class="row">
                <div class="custom-alert alert alert-success" role="alert" v-if="isSuccess">
                    Uniform updated successfully.
                </div>
                <div class="custom-alert alert alert-danger" role="alert" v-if="isError">
                    Please fill in the mandatory field(s).
                </div>

                <transition name="fade" mode="out-in">
                    <div v-show="toggleFilter" id="side-filter-col" class="col-lg-3">
                        <div class="side-filter">

                            <div class="title">
                                Filter
                            </div>

                            <div class="form-group">
                                <div class="label">Division</div>

                                <div>
                                    <div class="custom-control-inline pill-radio">
                                        <input id="north" type="checkbox" name="division" value="0" required class="custom-control-input" v-model="filter.division" @change="onChangeDivision()">
                                        <label class="" for="north">East</label>
                                    </div>
                                    <div class="custom-control-inline pill-radio">
                                        <input id="south" type="checkbox" name="division" value="1" required class="custom-control-input" v-model="filter.division" @change="onChangeDivision()">
                                        <label class="" for="south">West</label>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="label">Region</div>
                                <app-multi-select
                                        :options="regionOptions.map(regionOption => regionOption.id)"
                                        :custom-label="opt => regionOptions.find(x => x.id === opt).name"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        :preselect-first="false"
                                        :placeholder="'-- All Region --'"
                                        v-model="filter.region"
                                        @input="onChangeRegion">
                                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                                </app-multi-select>

                                <div class="selected-label" v-if="filter.region.length > 0">
                                    FILTER:
                                    <div v-for="region in filter.region" :key="region">{{ regionOptions.find(x => x.id === region).name}}</div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="label">Area</div>
                                <div class="custom-modal-select" :class="{ 'selected': filter.area.length > 0 }" v-b-modal.area-modal>
                                    <input type="button" class="form-control" :value="filter.area.length > 0 ? filter.area.length + ' selected' : '-- All Area --'">
                                </div>

                                <div class="selected-label" v-if="filter.area.length > 0">
                                    FILTER:
                                    <div v-for="area in filter.area" :key="area">{{ areaOptions.find(x => x.id === area).name}}</div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="label">Position</div>
                                <app-multi-select
                                        :options="positionOptions.map(positionOption => positionOption.id)"
                                        :custom-label="opt => positionOptions.find(x => x.id === opt).name"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        :preselect-first="false"
                                        :placeholder="'-- All Position --'"
                                        v-model="filter.position">
                                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                                </app-multi-select>

                                <div class="selected-label" v-if="filter.position.length > 0">
                                    FILTER:
                                    <div v-for="position in filter.position" :key="position">{{ positionOptions.find(x => x.id === position).name}}</div>
                                </div>
                            </div>

                            <div class="filter-action">
                                <button type="button" class="btn btn-ecdc btn-block" @click="setFilter()">Apply</button>
                                <button type="button" class="btn btn-link btn-block text-light" @click="clearFilter()">Clear Filter</button>
                            </div>
                        </div>
                    </div>
                </transition>

                <div id="table-content-col" :class="toggleFilter ? 'col-lg-9 filter-expanded' : 'col-lg'">

                    <div class="table-options row justify-content-between align-items-center">
                        <div class="col-sm">
                            <button @click='toggleFilter = !toggleFilter' type="button" class="btn btn-ecdc btn-filter">Filter</button>

                            <!-- <div class="table-search form-inline d-inline-block ml-4">
                                <input type="text" class="form-control" placeholder="Search by keyword">                         <button type="button" class="btn btn-ecdc btn-circle">
                                    <app-icon-search></app-icon-search>
                                </button>       
                            </div> -->
                        </div>
                        <div class="col-sm mt-3 mt-sm-0">
                            <app-paginate
                                :page-count="totalPage"
                                :click-handler="pagination"
                                :prev-text="'&laquo;'"
                                :next-text="'&raquo;'"
                                ref="paginateTop"
                                :container-class="'pagination justify-content-end'">
                            </app-paginate>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-striped table-hover result-table">
                            <thead>
                                <tr>
                                    <th>Brands</th>
                                    <th>Programme</th>
                                    <th>Division</th>
                                    <th>Region</th>
                                    <th>Area</th>
                                    <th>Available</th>
                                    <th>Occupied</th>
                                    <th>Damaged</th>
                                    <th class="text-center">Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr :class="{ 'editing table-form': selectedAsset }" :id="data.id" :key="data.id" v-for="data in shoeData">
                                    <td>Dunhill</td>
                                    <td>Programme</td>
                                    <td>South</td>
                                    <td>Jatimbanus</td>
                                    <td>Surabaya</td>
                                    <td class="form-col">
                                        <div class="row no-gutters row-cols-xl-2 row-cols-1">
                                            <div class="col sizing-info" :key="available.id" v-for="available in data.available">
                                                <label class="size-label">{{ available.size }}</label>
                                                <input v-if="selectedAsset === data.id" class="form-control" type="number" min="0" step="1"  v-model="available.amount" @input="checkValue(available.amount)">
                                                <div v-if="selectedAsset !== data.id" class="d-inline-block">
                                                    <span class="total-assets">{{ available.amount }}</span> units
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="form-col">
                                        <div class="row no-gutters row-cols-xl-2 row-cols-1">
                                            <div class="col sizing-info" :key="occupied.id" v-for="occupied in data.occupied">
                                                <label class="size-label">{{ occupied.size }}</label>
                                                <input v-if="selectedAsset === data.id" class="form-control" type="number" min="0" step="1" v-model="occupied.amount" @input="checkValue(occupied.amount)">
                                                <div v-if="selectedAsset !== data.id" class="d-inline-block">
                                                    <span class="total-assets">{{ occupied.amount }}</span> units
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="form-col">
                                        <div class="row no-gutters row-cols-xl-2 row-cols-1">
                                            <div class="col sizing-info" :key="damaged.id" v-for="damaged in data.damaged">
                                                <label class="size-label">{{ damaged.size }}</label>
                                                <input v-if="selectedAsset === data.id" class="form-control" type="number" min="0" step="1" v-model="damaged.amount" @input="checkValue(damaged.amount)">
                                                <div v-if="selectedAsset !== data.id" class="d-inline-block">
                                                    <span class="total-assets">{{ damaged.amount }}</span> units
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center" width="150">
                                        <button v-if="selectedAsset !== data.id" @click="editAsset(data.id)" class="btn btn-link btn-icon icon-right">
                                            Edit 
                                            <img class="icon" src="../assets/img/icon-edit.png" />
                                        </button>
                                        <div v-if="selectedAsset === data.id">
                                            <button class="btn btn-ecdc mr-2 mb-1" @click="updateShoe(data.id)" :disabled="hasError">
                                                Update 
                                            </button>
                                            <button @click="editAssetEnd" class="btn btn-ecdc btn-circle">
                                                <app-icon-cancel></app-icon-cancel>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="row justify-content-between align-itemscenter table-options">
                        <div class="col-lg col-6">
                            <select class="form-control custom-select" v-model="pageLimit" @change="pagination(1)">
                                <option value="15">15</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            per page
                        </div>
                        <div class="col-lg text-lg-center text-right col-6">
                            {{ showingResults }}
                        </div>
                        <div class="col-lg mt-lg-0 mt-3">
                            <app-paginate
                                :page-count="totalPage"
                                :click-handler="pagination"
                                :prev-text="'&laquo;'"
                                :next-text="'&raquo;'"
                                ref="paginateBottom"
                                :container-class="'pagination justify-content-end'">
                            </app-paginate>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-loader v-show="isLoading"></app-loader>

    </div>
</template>

<script>
import Loader from './Loader.vue'
import Paginate from 'vuejs-paginate'
// import IconSearch from '../svg/Search.vue'
import IconCancel from '../svg/Cancel.vue'
import {
    getAreas, 
    getRegions, 
    getShoes, 
    updateShoe
} from "../api";
import Multiselect from "vue-multiselect";

export default {
    components: {
        appLoader: Loader,
        appPaginate: Paginate,
        // appIconSearch: IconSearch,
        appIconCancel: IconCancel,
        appMultiSelect: Multiselect
    },
    data() {
        return {
            filter: {
                division: [],
                region: [],
                area: [],
                position: []
            },
            regions: [],
            regionOptions: [],
            areas: [],
            areaOptions: [],
            isLoading: true,
            isError: false,
            isSuccess: false,
            hasError: false,
            toggleFilter: true,
            selectedAsset: '',
            shoeData: '',
            totalPage: 0,
            pageLimit: 15,
            showingResults: '',
            positionOptions: [
                { name: 'GENERAL MANAGER', id: 1 },
                { name: 'GENERAL AFFAIR MANAGER', id: 2 },
                { name: 'IT MANAGER', id: 3 },
                { name: 'OFFICE ADMIN', id: 4 },
                { name: 'RECEPTIONIST', id: 5 },
                { name: 'SECURITY OFFICER', id: 6 },
                { name: 'DRIVER', id: 7 },
                { name: 'OFFICE BOY', id: 8 },
                { name: 'BUSINESS UNIT DIRECTOR', id: 9 },
                { name: 'BUSINESS DEVELOPMENT MANAGER', id: 10 },
                { name: 'STRATEGIC PLANNER', id: 11 },
                { name: 'ACCOUNT DIRECTOR', id: 12 },
                { name: 'ACCOUNT MANAGER', id: 13 },
                { name: 'ACCOUNT EXECUTIVE', id: 14 },
                { name: 'CREATIVE DIRECTOR', id: 15 },
                { name: 'ART DIRECTOR', id: 16 },
                { name: 'DESIGNER', id: 17 },
                { name: 'OPERATIONAL DIRECTOR', id: 18 },
                { name: 'ACTIVATION DIRECTOR', id: 19 },
                { name: 'REGIONAL AREA ACTIVATION MANAGER', id: 20 },
                { name: 'AREA ACTIVATION MANAGER', id: 21 },
                { name: 'ACTIVATION SUPERVISOR', id: 22 },
                { name: 'ADMINISTRATION EXECUTIVE (ACTIVATION)', id: 23 },
                { name: 'LOGISTIC OFFICER (ACTIVATION)', id: 24 },
                { name: 'SENIOR DATA INPUT', id: 25 },
                { name: 'DATA INPUT EXCECUTIVE', id: 26 },
                { name: 'SENIOR CALL CENTER', id: 27 },
                { name: 'CALL CENTER EXECUTIVE', id: 28 },
                { name: 'BA COORDINATOR (ACTIVATION)', id: 29 },
                { name: 'MARCOMM SUPERVISOR', id: 30 },
                { name: 'PROJECT MANAGER', id: 31 },
                { name: 'SENIOR PROJECT EXECUTIVE', id: 32 },
                { name: 'PROJECT EXECUTIVE', id: 33 },
                { name: 'EVENT DIRECTOR', id: 34 },
                { name: 'EVENT MANAGER', id: 35 },
                { name: 'EVENT EXECUTIVE', id: 36 },
                { name: 'FINANCE MANAGER', id: 37 },
                { name: 'FINANCE EXECUTIVE', id: 38 },
                { name: 'ACCOUNTS', id: 39 },
                { name: 'HR/LEGAL MANAGER', id: 40 },
                { name: 'HR EXECUTIVE', id: 41 },
                { name: 'LEGAL EXECUTIVE', id: 42 },
                { name: 'TEAM LEADER', id: 44 },
                { name: 'BA', id: 45 },
                { name: 'ADMIN SOUTH', id: 46 },
                { name: 'ADMIN NORTH', id: 47 },
                { name: 'OPERATIONAL ADMIN', id: 48 },
                { name: 'CDC ADMIN', id: 49 },
                { name: 'CLIENT (BENTOEL)', id: 50 },
                { name: '3WSR', id: 51 },
                { name: 'ARCO', id: 52 },
                { name: 'ASMO', id: 53 },
                { name: 'SUPER ADMIN', id: 99 }
            ],
        }
    },
    async mounted() {

        await this.getShoes(1);
        await this.getRegions();
        await this.getAreas();
        this.isLoading = false;
    },
    methods: {
        editAsset(id) {
            this.selectedAsset = id;
        },
        editAssetEnd() {
            this.selectedAsset = '';
        },
        checkValue(amount) {
            if(isNaN(amount) || amount === '' || amount < 0) {
                this.isError = true;
                this.hasError = true;
            } else {
                this.isError = false;
                this.hasError = false;
            }

        },
        async getShoes(pageNum) {

            try {

                const result = await getShoes(this.filter, pageNum, this.pageLimit);
                this.shoeData = result.data.data;

                this.totalPage = this.shoeData.total / this.pageLimit;

                if(this.totalPage % 1 !== 0)
                    this.totalPage = parseInt(this.totalPage) + 1;
                else
                    this.totalPage = parseInt(this.totalPage);

                let startPage = 1;

                if(pageNum !== 1)
                    startPage = (this.pageLimit * (pageNum - 1)) + 1;

                let endPage = pageNum * this.pageLimit;

                if(endPage >= this.shoeData.total)
                    endPage = this.shoeData.total;

                this.showingResults = "Showing " + startPage + " - " + endPage + " of " + this.shoeData.total + " results";
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async updateShoe(id) {

            this.isLoading = true;

            if(!this.hasError) {
                try {

                    await updateShoe(this.shoeData.filter(element => element.id === id));
                } 
                catch (err) {

                    alert(err.response.data.message);
                }

                this.selectedAsset = '';
                this.isLoading = false;
            } else {
                this.isError = true;
            }
        },
        async pagination(pageNum) {

            this.isLoading = true;

            if(pageNum !== 0)
                this.$refs.paginateTop.selected = this.$refs.paginateBottom.selected = pageNum;
            else
                pageNum = this.$refs.paginateBottom.selected;

            await this.getUsers(pageNum);

            this.isLoading = false;
        },
        async getRegions() {
        
            try {
                const result = await getRegions();
                this.regions = result.data.data;
                this.regionOptions = this.regions;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async getAreas() {
        
            try {
                const result = await getAreas();
                this.areas = result.data.data;
                this.areaOptions = this.areas;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        onChangeDivision() {

            const _this = this;
            this.regionOptions = [];
            this.filter.region = [];
            this.areaOptions = this.areas;
            this.filter.area = [];

            if(this.filter.division.length > 0) {

                this.filter.division.forEach(division => {

                    const found = _this.regions.filter(value => value.division === division);

                    found.forEach(value => {
                        _this.regionOptions.push(value);
                    });
                });
            }
            else {

                this.regionOptions = this.regions;
            }
        },
        onChangeRegion() {

            const _this = this;
            this.areaOptions = [];
            this.filter.area = [];

            if(this.filter.region.length > 0) {

                this.filter.region.forEach(region => {

                    const found = _this.areas.filter(value => value.region_id === region);

                    found.forEach(value => {
                        _this.areaOptions.push(value);
                    });
                });
            }
            else {

                this.areaOptions = this.areas;
            }
        },
        clearArea() {

            this.filter.area = [];
        },
        clearFilter() {

            this.filter.division = [];
            this.filter.region = [];
            this.filter.area = [];
            this.filter.position = [];

            this.regionOptions = this.regions;
            this.areaOptions = this.areas;
        },
        async setFilter() {

            this.isLoading = true;
            await this.getUsers(1);
            this.isLoading = false;
        }
    }
}
</script>